import { isBlockedDeliveryCode } from './delivery-status.js';
const inRange = (v, lo, hi) => v != null && v >= lo && v <= hi;
/** Souterrain (7xxx) : au-delà, un devis est exigé au release. Exporté pour l'aide à la distance du Tutoriel
 *  (N32.6) — une seule valeur, lue au même endroit par l'écran qui explique et par la règle qui s'applique. */
export const QUOTE_DISTANCE_M = 28;
/** Aérien (9xxx) : au-delà, un point d'ancrage intermédiaire est nécessaire. Même raison d'export. */
export const AERIAL_ANCHOR_DISTANCE_M = 60;
const ATTENTION_RULES = [
    // BLOCKED delivery codes (user annex 2026-08-03): 2001-2015 « Blocked » / 2101-2112 « Not-Homes
    // Passed » — the address is not connectable as-is; the exact reason is decoded on the delivery-
    // status line of the reference panel. First in the catalogue: it's the gravest signal.
    {
        id: 'deliveryBlocked',
        when: (a) => isBlockedDeliveryCode(a.deliveryStatus),
    },
    // Underground 7xxx + estimated street distance over 28 m → a quote is required; the Release recipe
    // stamps quote_required='YES_ESTIMATED_DISTANCE' on the address (see releaseAddress).
    {
        id: 'quoteDistance',
        when: (a) => inRange(a.deliveryStatus, 7000, 7999)
            && a.lengthEstimateFromStreet != null && a.lengthEstimateFromStreet > QUOTE_DISTANCE_M,
    },
    // Aerial 9xxx: no maximum length, but beyond 60 m an intermediate anchor point is needed — without
    // it the cable would sag under its own weight. No DMP field exists for this; app-side info only.
    {
        id: 'aerialAnchor',
        when: (a) => inRange(a.deliveryStatus, 9000, 9999)
            && a.lengthEstimateFromStreet != null && a.lengthEstimateFromStreet > AERIAL_ANCHOR_DISTANCE_M,
    },
    // DMP release block (home_release_blocked_reason: BLOCKED_BY_SYNDICUS / DESIGN_PROBLEM / …):
    // the address must not be released blindly — check the reason (shown in the reference panel) first.
    {
        id: 'releaseBlocked',
        when: (a) => a.homeReleaseBlockedReason != null && a.homeReleaseBlockedReason !== '',
    },
];
/** The ids of the rules that fire for these attributes, in catalogue order ([] for null/no data). */
export function computeAttentionPoints(a) {
    if (!a)
        return [];
    return ATTENTION_RULES.filter((r) => r.when(a)).map((r) => r.id);
}
//# sourceMappingURL=attention-rules.js.map